import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rnpl-truncate-tooltip',
  template: '{{ text }}',
  styleUrls: ['./truncate-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TruncateTooltipComponent {
  public text = '';
}
